import classicTheme from './classic';
import minimalTheme from './minimal';
import compactTheme from './compact';
import darkTheme from './dark';
import islandsTheme from './islands';
import bentoTheme from './bento';
import stepsTheme from './steps';

const themes = {
  classic: classicTheme,
  minimal: minimalTheme,
  compact: compactTheme,
  dark: darkTheme,
  islands: islandsTheme,
  bento: bentoTheme,
  steps: stepsTheme,
};

export const getTheme = (themeName) => themes[themeName] || themes.classic;
export const getAvailableThemes = () => Object.keys(themes);
export const getThemeDefaultHighlightColor = (themeName) => {
  const theme = themes[themeName] || themes.classic;
  return theme.defaultHighlightColor || '#00d4ff';
};
